// 1. A replacer: when JSON.stringify sees a Set, swap it for a tag + array
export const setReplacer = (_key, value) => {
  if (value instanceof Set) {
    return {
      __type: 'Set',
      data: [...value],
    };
  }
  return value;
};

// 2. A reviver: when JSON.parse sees that tag, rebuild the Set
export const setReviver = (_key, value) => {
  if (
    value !== null &&
    typeof value === 'object' &&
    value.__type === 'Set' &&
    Array.isArray(value.data)
  ) {
    return new Set(value.data);
  }
  return value;
};
